import { createSlice } from '@reduxjs/toolkit';
import { products } from '../../data/mockData';

const initialState = {
  products,
  selectedCategory: 'all',
  hoveredProduct: null,
};

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setHoveredProduct: (state, action) => {
      state.hoveredProduct = action.payload;
    },
  },
});

export const { setCategory, setHoveredProduct } = shopSlice.actions;

// Selectors
export const selectAllProducts = (state) => state.shop.products;
export const selectSelectedCategory = (state) => state.shop.selectedCategory;
export const selectHoveredProduct = (state) => state.shop.hoveredProduct;

export const selectFilteredProducts = (state) => {
  const category = state.shop.selectedCategory;
  if (category === 'all') {
    return state.shop.products;
  }
  return state.shop.products.filter(product => product.category === category);
};

export default shopSlice.reducer;